module.exports = __webpack_public_path__ + "img/image.d1d94612.svg";